<div id="scroll-hint" [class.wide]="newMessagesCount">
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
    <path d="M6 4.89995L10.6 0.299951L12 1.69995L6 7.69995L5.24537e-07 1.69995L1.4 0.29995L6 4.89995Z" fill="#1C1B1F" />
  </svg>
  <span *ngIf="newMessagesCount">New message{{ newMessagesCount > 1 ? 's' : '' }}</span>
</div>
